import { render, staticRenderFns } from "./InvoiceReminderDlg.vue?vue&type=template&id=923a6990&"
import script from "./InvoiceReminderDlg.vue?vue&type=script&lang=js&"
export * from "./InvoiceReminderDlg.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReminderDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports